import { render, staticRenderFns } from "./liabilities.vue?vue&type=template&id=03bcdd30&"
import script from "./liabilities.vue?vue&type=script&lang=js&"
export * from "./liabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports